import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Divider, Grid, Paper, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import Ratings from '../Ratings'

function DigitalCertificateCarRating({ certificateData, index }) {
  const { basicData, rating } = certificateData
  const { t } = useTranslation()

  return (
    <Paper elevation={0}>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={6} md={4}>
          <Box
            sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: '100%',
            }}
          >
            <Box>
              <Typography variant="h3" sx={{ mb: 1 }}>
                {`${basicData.make} ${basicData.model}`}
              </Typography>
              <Typography>{basicData.version}</Typography>
            </Box>
            <Ratings
              big
              label={t('summaryRatingLabel')}
              orientation="vertical"
              score={basicData.controlRating || 0}
              starSize={48}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Box
            sx={({ spacing }) => ({
              p: { xs: 3, lg: index ? spacing(3, 0) : 3 },
            })}
          >
            <Typography variant="h3">{t('digital.rating')}</Typography>
            <Ratings label={t('summaryLabel1')} score={rating?.body || 0} />
            <Ratings label={t('summaryLabel2')} score={rating?.interior || 0} />
            <Ratings
              label={t('summaryLabel3')}
              score={rating?.equipment || 0}
            />
            <Ratings label={t('tires')} score={rating?.tyres || 0} />
            <Ratings
              label={t('summaryLabel5')}
              score={rating?.technical || 0}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 3,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img src={basicData.imageUrl} alt="" style={{ width: '100%' }} />
          </Box>
        </Grid>
      </Grid>
      <Divider />
    </Paper>
  )
}
DigitalCertificateCarRating.propTypes = {
  certificateData: PropTypes.object,
  index: PropTypes.bool,
}

DigitalCertificateCarRating.defaultProps = {
  certificateData: {},
  index: false,
}

export default DigitalCertificateCarRating
